import { RefObject } from 'react';
import { ClinicalBarData, ClinicalDataBars, ClinicalHeader } from '@features/components/ClinicalBarChart';
import { OrganType } from '@/api/apis/case';

type HeartClinicalDataProps = {
  listItemRefs?: RefObject<(HTMLDivElement | null)[]>;
  listContainerRef?: RefObject<HTMLDivElement | null>;
  lactate: ClinicalBarData[];
  ocsPt: string;
};

export const HeartClinicalData = ({ lactate, ocsPt, listContainerRef, listItemRefs }: HeartClinicalDataProps) => {
  return (
    <div className="flex flex-col w-full gap-1">
      <ClinicalHeader
        currentValue={lactate.at(-1)?.value}
        prevValue={lactate.at(-2)?.value}
        diffLabel="mmol/L"
        measurementUnits="(mmol/L)"
        parameter="Lactate"
        ocsTime={ocsPt}
      />
      <div ref={listContainerRef} className="w-full overflow-auto">
        <ClinicalDataBars
          listItemRefs={listItemRefs}
          cardView
          showLabel
          showValue
          values={lactate}
          organType={OrganType.Heart}
          verticalView={lactate.length > 3}
        />
      </div>
    </div>
  );
};
